import React, { useEffect, useState } from 'react';
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import Home from './Home';
//import './style.css'

function App() {


  return (
    <>

      <Home />




    </>

  );
}

export default App;
